// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"9a710748","219":"2f439b4a","389":"2f439b4a","396":"2f439b4a","462":"2f439b4a","788":"2f439b4a"}[chunkId] + ".chunk.css";
};